import { createSlice } from "@reduxjs/toolkit";
import { LOADING_STATE } from "types/general";
import { REVIEWS_SLICE_NAME, initialState } from "./constants";
import { fetchReviews } from "./controllers";

const reviewsSlice = createSlice({
  name: REVIEWS_SLICE_NAME,
  initialState,
  reducers: {
    resetReviews: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviews.pending, (state) => {
        state.loadingState = LOADING_STATE.pending;
      })
      .addCase(fetchReviews.fulfilled, (state, { payload }) => {
        state.data = payload;
        state.loadingState = LOADING_STATE.fulfilled;
      })
      .addCase(fetchReviews.rejected, (state) => {
        state.loadingState = LOADING_STATE.rejected;
      });
  },
});

export const { resetReviews } = reviewsSlice.actions;

export default reviewsSlice;
